import React, {Suspense, lazy} from 'react';
import { PageLoading } from '../../Components/Loading';

const TheExpenses = lazy(() => import(/* webpackChunkName: "expenses" */'./TheExpenses'));

const Expenses = () => {
    return <Suspense fallback={<PageLoading />}>
        <TheExpenses />
    </Suspense>
}

export default Expenses;
